import "core-js/modules/es.array.find";
// 対象要素を取得
var $root = $('#leafContentWideContainer');
var $panels = $root.find('.leafitem');
var $buttons = $root.find('.opener'); // 初期化処理

$root.attr('role', 'tablist');
$('#w01_tab').attr('aria-expanded', 'true'); // 初期表示ボタン

$('#w01').attr('aria-hidden', 'false'); // 初期表示パネル
// イベントハンドラ

$buttons.on('click', function (e) {
  var $button = $(this);
  var $panel = $('#' + $button.attr('aria-controls'));
  $buttons.attr('aria-expanded', 'false');
  $panels.attr('aria-hidden', 'true'); // ステートに応じてボタンとパネルの属性値を変更

  if ($button.attr('aria-expanded') === 'false') {
    $button.attr('aria-expanded', 'true');
    $panel.attr('aria-hidden', 'false');
  } else {
    $button.attr('aria-expanded', 'false');
    $panel.attr('aria-hidden', 'true');
  }

  e.stopPropagation(); // 親要素へのバブリングを停止

  e.preventDefault(); // 要素の標準イベントを停止
});